import { render } from "./CompositionTree.vue?vue&type=template&id=5b1825e0&scoped=true&ts=true"
import script from "./CompositionTree.vue?vue&type=script&lang=ts"
export * from "./CompositionTree.vue?vue&type=script&lang=ts"

import "./CompositionTree.vue?vue&type=style&index=0&id=5b1825e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1825e0"]])

export default __exports__